import { render, staticRenderFns } from "./CadastrarGerenteTerritorial.vue?vue&type=template&id=52ca7624&lang=pug"
import script from "./CadastrarGerenteTerritorial.vue?vue&type=script&lang=js"
export * from "./CadastrarGerenteTerritorial.vue?vue&type=script&lang=js"
import style0 from "./CadastrarGerenteTerritorial.vue?vue&type=style&index=0&id=52ca7624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports